import {useEffect, useRef, useState} from "react";
import {
  SActionBtn,
  SFuncModal, SFuncModalFormRef,
  SListTabs,
  SLowcodeList,
  SSearchForm,
  STableActions,
} from "shj-components";
import {cloneDeep, isEmpty} from "lodash-es";
import {Button, Col, message, Modal, Radio, Row, Tabs} from "antd";
import custom from "./tagConfig/customConfig.tsx";
import styles from './index.module.less'
import {deleteById, getEnum, getTagTreeByType, updateTagTypeOrTag} from "@/services/customerServices";
import {AddOrEditTagTypeModal} from "@/pages/customerConfig/customerLabel/addOrEditModal/tagType.tsx";
import {AddOrEditTagModal} from "@/pages/customerConfig/customerLabel/addOrEditModal/tag.tsx";
import {onMatchFormSearch} from './util'

interface IProps {
  tagType: string;
  config: Record<string, any>
}

const TagItem = (props: IProps) => {
  const {config, tagType} = props;
  const searchFormRef = useRef();
  const listRef = useRef();
  const tagRef = useRef();
  const editTagTypeRef = useRef<SFuncModalFormRef>({onReset: undefined, onFinish: undefined});
  const editTagRef = useRef<SFuncModalFormRef>({onReset: undefined, onFinish: undefined});
  const [selectedRow, setSelectedRow] = useState<Record<string, any>[]>([]);
  const [tagsMap, setTagsMap] = useState(new Map());
  const [tagTypeTree, setTagTypeTree] = useState({id: '0', label: '根节点', children: []});
  const [tagChooseTypeList, setTagChooseTypeList] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [tagChooseType, setTagChooseType] = useState<string>('multiple');

  useEffect(() => {
    getTagChooseType()
  }, []);

  useEffect(() => {
    fetchList();
  }, [tagType])

  useEffect(() => {
    if (btnDisabled()) tagRef.current?.updateDataSource([]);
    const current = selectedRow?.[0]
    if (current && !isEmpty(tagsMap)) {
      console.log(datasource)
      datasource.length ? tagRef.current?.updateDataSource(tagsMap.get(current.id) || []) : tagRef.current?.updateDataSource([]);
    }
    setTagChooseType(current?.object.inputType || 'multiple')
  }, [selectedRow, tagsMap, datasource])

  const fetchList = () => {
    getTagTreeByType(tagType).then((res: Record<string, any>) => {
      const {records} = res;
      const tagList = [];
      delTree(records, tagList);
      delTags(tagList);
      listRef.current?.updateDataSource(records);
      setDatasource(records)
      setTagTypeTree({...tagTypeTree, children: records})
    })
  }

  // 获取标签组 选择类型
  const getTagChooseType = async () => {
    const type = await getEnum('com.shj.saas.plus.crm.enums.InputTypeEnum');
    setTagChooseTypeList(type)
  }

  // 取出所有标签数据
  const delTree = (data = [], tagsList: any[] = []) => {
    return data.reduce((res: any[], item: Record<string, any>): any => {
      if (item.object.groupTag === 'tag') {
        tagsList.push(item)
      } else {
        if (item.children) {
          const res = delTree(item.children, tagsList);
          if (res) item.children = res; else delete item.children
        }
        res.push(item)
        if (item.id === selectedRow[0]?.id) setSelectedRow([{...item}]);
        return res;
      }
    }, [])
  };
  // 整合标签数据为map对象
  const delTags = (data: any[]) => {
    const tagsMap = new Map();
    data.forEach((tag: any) => {
      if (tagsMap.has(tag.object.pid)) {
        tagsMap.set(tag.object.pid, [...tagsMap.get(tag.object.pid), tag])
      } else {
        tagsMap.set(tag.object.pid, [tag])
      }
    })
    setTagsMap(tagsMap);
  }

  const onReload = () => {
    fetchList();
  }
  const onFinish = (values) => {
    const searchKeys = Object.keys(values);
    if (searchKeys.length > 0) {
      let res: any = cloneDeep(tagTypeTree.children);
      searchKeys.forEach(key => {
        res = onMatchFormSearch(values[key] ? {[key]: values[key]} : {}, res);
      })
      setDatasource(res)
      listRef.current?.updateDataSource(res);
    } else onReload()
  };
  const onReset = () => {
    listRef.current?.updateDataSource(tagTypeTree.children);
    setDatasource(tagTypeTree.children)
    onReload()
  };

  const onChangeRadio = (e: any) => {
    const value = e.target.value;
    // Modal.confirm({
    //   title: '修改标签组选择',
    //   content: `是否确认修改标签组选择类型为：${tagChooseTypeList.find(item => item.key === value)?.description}`,
    //   onOk() {
    setTagChooseType(value);
    updateTagTypeOrTag({data: {id: selectedRow[0].id, inputType: value}}).then(() => {
      message.success('操作成功')
      onReload();
    })
    //   }
    // })
  }

  const onAddTagType = (currentType?) => {
    console.log(currentType)
    if(currentType?.object?.weight === 3) {
      return message.error('最多增加3级分类！', 6);
    }
    if (currentType && tagsMap.has(currentType.id))
      return message.error('分类下不能同时存在分类和标签', 6);
    onAddOrEditType('新增分类', {selectedType: currentType})
  }

  const onEditTagType = (record) => {
    onAddOrEditType('编辑分类', {record})
  }

  const onAddOrEditType = (title: string, options) => {
    const destroy = () => {
      dialog.destroy();
    };
    const dialog = SFuncModal({
      title,
      formRef: editTagTypeRef.current,
      vanish: true,
      content: <AddOrEditTagTypeModal tagTypeTree={tagTypeTree} reload={onReload}
                                      editRef={editTagTypeRef}
                                      onClose={destroy}
                                      {...options}/>
    })
  }

  const onAddTag = () => {
    const destroy = () => {
      dialog.destroy();
    };
    const dialog = SFuncModal({
      title: '新增标签',
      formRef: editTagRef.current,
      vanish: true,
      content: <AddOrEditTagModal editRef={editTagRef} reload={onReload} selectedType={selectedRow[0]} onClose={destroy}/>
    })
  }
  const onEditTag = (record) => {
    const destroy = () => {
      dialog.destroy();
    };
    const dialog = SFuncModal({
      title: '编辑标签',
      formRef: editTagRef.current,
      vanish: true,
      content: <AddOrEditTagModal editRef={editTagRef} reload={onReload} record={record} onClose={destroy}/>
    })
  }

  const onDelTagTypeOrTag = (record) => {
    if (!isEmpty(record.children) || tagsMap.has(record.id)) {
      return message.error('该分类存在子数据,不允许删除', 6)
    }
    Modal.confirm({
      title: '确认删除',
      content: '删除后标签不可恢复，确认删除？',
      onOk() {
        deleteById(record.id).then(() => {
          message.success('删除成功');
          fetchList();
          setSelectedRow([])
        })
      }
    })
  }

  const extension = {
    request: {},
    events: {
      onAddTagType: () => onAddTagType(),
    },
    selectedRow,
    onSelectedRowChange: (_: string[], rows: any[]) => {
      setSelectedRow(rows);
    },
    customRender: {
      actionRender(_: undefined, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onEditTagType(record)}>编辑</SActionBtn>
          <SActionBtn onClick={() => onAddTagType(record)}>添加分类</SActionBtn>
          <SActionBtn danger onClick={() => onDelTagTypeOrTag(record)}>
            删除
          </SActionBtn>
        </STableActions>
      }
    }
  }

  console.log(extension,'ex')

  const btnDisabled = () => !(selectedRow.length > 0 && !selectedRow[0]?.children);
  const extension1 = {
    request: {},
    events: {onAddTag: () => onAddTag()},
    customRender: {
      addTagRender() {
        return <div className={styles.flex_between}>
          <Button type={'primary'} onClick={() => onAddTag()} disabled={btnDisabled()}>新增</Button>
          <div className={styles.radio_box}>
            <span>标签选择：</span>
            <Radio.Group disabled={btnDisabled()} onChange={onChangeRadio}
                         value={tagChooseType}>
              {tagChooseTypeList.map((type: Record<string, any>) => <Radio key={type.key}
                                                                           value={type.key}>{type.description}</Radio>)}
            </Radio.Group>
          </div>
        </div>
      },
      actionRender(_: undefined, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onEditTag(record)}>编辑</SActionBtn>
          <SActionBtn danger onClick={() => onDelTagTypeOrTag(record)}>
            删除
          </SActionBtn>
        </STableActions>
      }
    }
  }

  return <>
    <div className={styles.searchBox}>
      <SSearchForm ref={searchFormRef} {...config.searchConfig} onFinish={onFinish}
                   onReset={onReset}/>
    </div>

    <Row align={'stretch'} className={styles.tableWrapBox}>
      <Col span={14} className={styles.leftTable}>
        <SLowcodeList rowKey={'id'} key={tagType} ref={listRef} config={config.tableConfig} {...extension} />
      </Col>
      <Col span={10} className={styles.rightTable}>
        <SLowcodeList ref={tagRef} config={config.tagConfig} {...extension1} />
      </Col>
    </Row>

  </>
}

const TagManage = () => {
  return <TagItem config={custom} tagType={'custom'}/>;
}

export default TagManage;